import { Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import RoomtypeIcon from '@material-ui/icons/MeetingRoom'
import React from 'react'

import { getTranslate } from '../../localization'
import { NumberFieldData } from '../../mockData/inventory'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface AllocateRoomtypeRowProps {
  name: string
  pooledAvailability: NumberFieldData[]
  totalAvailability: NumberFieldData[]
  numberOfRoom: number
  weekendIndexes: number[]
  numberOfChannels: number
  showChannels: boolean
  setshowChannels: React.Dispatch<React.SetStateAction<boolean>>
}

const AllocateRoomtypeRow: React.FC<AllocateRoomtypeRowProps> = ({
  name,
  numberOfRoom,
  pooledAvailability,
  //   totalAvailability,
  weekendIndexes,
  numberOfChannels,
  showChannels,
  setshowChannels
}) => {
  const classes = useStyles()

  return (
    <div>
      <div className={classes.roomTypeRow}>
        <div className={classes.rowNameContainer}>
          <div className={classes.roomIcon}>
            <RoomtypeIcon />
          </div>
          <Typography variant="h4" className={classes.rowName}>
            {getTranslate(name)}
          </Typography>{' '}
          <Typography
            variant="h6"
            className={classes.numberOfRatePlans}
            component="span"
            onClick={() => setshowChannels(!showChannels)}>
            {numberOfChannels} {getTranslate('Channels')}
          </Typography>
          <div className={classes.ratePlansLoading}>
            <ArrowRightIcon
              className={[
                classes.channelArrowRight,
                showChannels ? classes.channelArrowRightCollapsed : ''
              ].join(' ')}
            />
          </div>
        </div>
        <div className={classes.dayContainer}>
          <Typography variant="h5">
            {getTranslate('pooled') + ' / '}
            {numberOfRoom}
          </Typography>
        </div>
        {pooledAvailability?.map((availItem, index) => (
          <div
            key={`${name}-${availItem.date}`}
            className={[
              classes.dayContainer,
              weekendIndexes.includes(index % 7)
                ? classes.weekendDayContainer
                : ''
            ].join(' ')}>
            <Typography variant="body1">{availItem.value}</Typography>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AllocateRoomtypeRow
